import _isNil from 'hs-lodash/isNil';
import _omitBy from 'hs-lodash/omitBy';
import { useCallback, useMemo, useState } from 'react';
import AssociationModal from '../components/AssociationModal/AssociationModal';
import { defaultAssociationModalContextProps } from '../contexts/associationModal/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const useAssociationModal = props => {
  const definedProps = _omitBy(props, _isNil);
  const [showModal, setShowModal] = useState(false);
  const closeHandler = () => setShowModal(false);
  const openModal = () => setShowModal(true);
  const onSubmit = useCallback(() => {
    closeHandler();
    if (typeof definedProps.onSubmitAssociation === 'function') {
      definedProps.onSubmitAssociation();
    }
  }, [definedProps]);
  const componentProps = useMemo(() => Object.assign({}, defaultAssociationModalContextProps, definedProps, {
    closeModal: closeHandler,
    showModal,
    onSubmitAssociation: onSubmit
  }), [definedProps, onSubmit, showModal]);
  return [openModal, /*#__PURE__*/_jsx(AssociationModal, Object.assign({}, componentProps), "association-modal")];
};
export default useAssociationModal;